/**
 * Routes that may be served as prerendered HTML (react-snap / seo:snap).
 * Client-side React Router transitions from these pages can update the URL
 * without swapping the hydrated DOM — use a full document load instead.
 */
export function isMarketingPrerenderPath(pathname) {
  const p = pathname || '/';
  if (
    p === '/'
    || p === '/pricing'
    || p === '/about'
    || p === '/privacy'
    || p === '/terms'
    || p === '/e-commerce'
    || p === '/location-visualisation'
    || p === '/coming-soon'
  ) {
    return true;
  }
  if (p.startsWith('/blog') || p.startsWith('/documentation')) return true;
  return false;
}
